export enum DiscussionStatusEnum{
    Ouvert,
    Ferme
}